import { render } from "./PriseEnChargeSociale.vue?vue&type=template&id=15d635b7&scoped=true"
import script from "./PriseEnChargeSociale.vue?vue&type=script&lang=js"
export * from "./PriseEnChargeSociale.vue?vue&type=script&lang=js"

import "./PriseEnChargeSociale.vue?vue&type=style&index=0&id=15d635b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d635b7"]])

export default __exports__